var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import { Accordion } from "react-bootstrap";
import "@frameworks/salesjourney/stylesheets/components/Features/SalesReporting/RmPartnerReports.scss";
import ReportsByCategory from "./ReportsByCategory";
import SearchField from "@frameworks/salesjourney/components/Generic/SearchField";
import di from "../SalesReporting/di/serviceLocator";
import Loader from "../../../../shared-library/components/Loader";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
var RmPartnerReport = function () {
    var _a, _b;
    var _c = __read(useState(""), 2), searchText = _c[0], setSearchText = _c[1];
    var _d = __read(useState(undefined), 2), searchList = _d[0], setSearchList = _d[1];
    var _e = __read(useState(undefined), 2), allReportList = _e[0], setAllReportList = _e[1];
    var _f = __read(useState(true), 2), loader = _f[0], setLoader = _f[1];
    var getAllReports = function () {
        setLoader(true);
        di.salesReporting
            .getAllReport()
            .then(function (resp) {
            setAllReportList(resp);
            setSearchList(resp);
            setLoader(false);
        })
            .catch(function (error) {
            console.log("error", error);
            setLoader(false);
        });
    };
    useEffect(function () {
        if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) >= 2) {
            setSearchList(function (prev) {
                var searchList = [];
                prev === null || prev === void 0 ? void 0 : prev.groupList.map(function (reportsList) {
                    var _a;
                    searchList = __spreadArray(__spreadArray([], __read(searchList), false), __read((_a = reportsList === null || reportsList === void 0 ? void 0 : reportsList.subReportGroupList) === null || _a === void 0 ? void 0 : _a.filter(function (report) { var _a; return (_a = report === null || report === void 0 ? void 0 : report.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText.toLowerCase()); })), false);
                });
                var updatedList = __assign(__assign({}, prev), { groupList: [
                        {
                            groupName: "Search Result",
                            subReportGroupList: searchList,
                        },
                    ] });
                return updatedList;
            });
        }
        else if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) === 0) {
            setSearchList(allReportList);
        }
    }, [searchText]);
    useEffect(function () {
        getAllReports();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(GridContainer, { parentClass: "rm-partner-report-dashboard position-relative" },
            loader ? React.createElement(Loader, null) : React.createElement(React.Fragment, null),
            React.createElement("div", { className: "heading-search-container d-flex align-items-center justify-content-between" },
                React.createElement("span", { className: "DMSan_28_700 txt-midnight-blue" }, "RM Partner Reports"),
                React.createElement("div", { className: "search-container" },
                    React.createElement(SearchField, { searchText: searchText, setSearchText: setSearchText, placeholder: "Search Reports", searchIcon: "", parentClass: "search-input-block d-flex align-items-center" }))),
            React.createElement("div", { className: "reports-by-category pb-1" },
                React.createElement(Accordion, { defaultActiveKey: "Search Result" }, ((_a = searchList === null || searchList === void 0 ? void 0 : searchList.groupList) === null || _a === void 0 ? void 0 : _a.length) > 0 ? ((_b = searchList === null || searchList === void 0 ? void 0 : searchList.groupList) === null || _b === void 0 ? void 0 : _b.map(function (oneCategoryReports) { return (React.createElement(ReportsByCategory, { reportsByCategory: oneCategoryReports })); })) : (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })))))));
};
export default RmPartnerReport;
